import gsap, { SplitText } from '@lib/gsap'
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";

export default function (element: HTMLElement, dataset: any) {
  let splitEl: any
  const availableWrap = document.querySelector('.hero_content_wrap .g_tag_wrap');
  const skillsTags = document.querySelectorAll('.hero_skills_wrap .g_tag_wrap');
  onMount(() => {
    splitEl = new SplitText(element.querySelector('h1'), {
      type: 'lines, words',
      linesClass: 'u-overflow-hidden'
    })

    gsap.set(splitEl.words, {
      yPercent: 100
    })

    gsap.set(skillsTags, {
      yPercent: gsap.utils.wrap([-50, 50, -50]),
      xPercent: gsap.utils.wrap([-50, 0, 50]),
      opacity: 0
    })

    gsap.set(availableWrap, {
      yPercent: 90,
      opacity: 0,
      filter: 'blur(20px)'
    })

    gsap.set('.hero_content_img', {
      opacity: 0
    })

  })

  onPageIn(async () => {

    let tl = gsap.timeline({ paused: true, })

    tl.to(splitEl.words, {
      yPercent: 0,
      stagger: 0.01
    })

    tl.to(skillsTags, {
      yPercent: 0,
      xPercent: 0,
      opacity: 1
    }, '<+=0.25')

    tl.to(availableWrap, {
      yPercent: 0,
      opacity: 1,
      filter: 'blur(0px)'
    }, '<')

    tl.to('.hero_content_img', {
      opacity: 1,
      delay: 0.7,
      duration: 3
    }, '<')

    await tl.play()
  })
}